import type { VacationTerm } from '@/lib/types';

type Props = {
  terms: VacationTerm[];
  onReuse: (term: VacationTerm) => void;
  onDelete: (term: VacationTerm) => void;
};

function formatEnded(dateStr: string | null): string {
  if (!dateStr) return '종료일 없음';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return '종료일 없음';
  return `${d.getFullYear()}.${d.getMonth() + 1}.${d.getDate()} 종료`;
}

export default function VacationPastTermList({ terms, onReuse, onDelete }: Props) {
  if (terms.length === 0) return null;

  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-white">
      <div className="flex items-center gap-2 border-b border-background-200 bg-background-50 px-4 py-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-200 text-foreground-600">
          <i className="ri-history-line text-lg"></i>
        </span>
        <div>
          <span className="text-sm font-bold text-foreground-950">지난 방학특강</span>
          <span className="ml-2 text-xs text-foreground-500">
            종료된 시간표는 그대로 남아 있어요. 다음 방학특강 때 다시 사용할 수 있어요.
          </span>
        </div>
      </div>

      <div className="divide-y divide-background-100">
        {terms.map((t) => (
          <div
            key={t.id}
            className="flex flex-col gap-3 px-4 py-3 sm:flex-row sm:items-center sm:justify-between"
          >
            <div className="flex min-w-0 items-center gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                <i className="ri-snowy-line"></i>
              </span>
              <div className="min-w-0">
                <span className="block truncate text-sm font-semibold text-foreground-900">
                  {t.name}
                </span>
                <span className="text-xs text-foreground-500">{formatEnded(t.ended_at)}</span>
              </div>
            </div>

            <div className="flex shrink-0 flex-wrap items-center gap-2">
              <button
                type="button"
                onClick={() => onReuse(t)}
                className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-500 px-3 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600"
              >
                <i className="ri-repeat-line"></i> 다시 사용
              </button>
              <button
                type="button"
                onClick={() => onDelete(t)}
                title="이 방학특강 기록 삭제"
                className="inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-sm font-medium text-foreground-600 transition-colors hover:bg-background-100"
              >
                <i className="ri-delete-bin-line"></i>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}